export const enum TrackEvents {
  TRACK_SELECTED = "track_selected",
  TRACK_LOADED = "track_loaded",
}

export type TrackLoadedEvent = {
  type: TrackEvents.TRACK_SELECTED;
  id: string;
};

export function fireEvent(type: TrackEvents, data: Omit<TrackLoadedEvent, "type">) {
  const event = new CustomEvent(type, { detail: data });
  dispatchEvent(event);
}
